import {IconButtonProps, IconButton} from '@mui/material';
import iconView from '../../asset/icons/icon_view.svg';

const IconViewButton: React.FC<IconButtonProps> = ({
  color = 'primary',
  ...buttonProps
}) => {
  return (
    <IconButton {...buttonProps} title='View' aria-label='view' color={color}>
      <img src={iconView} alt='' />
    </IconButton>
  );
};

export default IconViewButton;
